import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './Home/Home'
import Legal from './Account/Legal/Legal'
import ChangePass from './Account/ChangePass/ChangePass'
import NotFound from './NotFound/NotFound'
import Loading from 'src/components/Loading/Loading'
import {
  AllInstallations,
  ChangeInstallations,
  Events,
  SocDashboard,
  SocUser,
  SocUsers
} from './Soc'
import {
  AllManteinances,
  ManteinanceDashboard,
  PreventiveByDate,
  SingleManteinance
} from './Manteinance'
import {
  Digital,
  DigitalPredictionDashboard,
  DigitalIntelligenceDashboard,
  Multi,
  Descriptive,
  Risks
} from './Digital'
import { Contract, Home as IncidencesHome, Incident } from './Incidences'

const PrivateRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="soc">
        <Route index element={<SocDashboard />} />
        <Route path="installations" element={<AllInstallations />} />
        <Route
          path="change-installations/:ids/:mode?"
          element={<ChangeInstallations />}
        />
        <Route path="events/incidents" element={<Events type="incidents" />} />
        <Route path="events/requests" element={<Events type="requests" />} />
        <Route path="users" element={<SocUsers />} />
        <Route path="users/:id?" element={<SocUser />} />
      </Route>
      <Route path="manteinance">
        <Route index element={<ManteinanceDashboard />} />
        <Route
          path="installation/:installationId"
          element={<ManteinanceDashboard />}
        />
        <Route
          path="corrective"
          element={<AllManteinances type="corrective" />}
        />
        <Route
          path="preventive"
          element={<AllManteinances type="preventive" />}
        />
        <Route path="preventive/date/:date" element={<PreventiveByDate />} />
        <Route
          path="corrective/installation/:installationId"
          element={<AllManteinances type="corrective" />}
        />
        <Route
          path="preventive/installation/:installationId"
          element={<AllManteinances type="preventive" />}
        />
        <Route
          path="corrective/:id"
          element={<SingleManteinance type="corrective" />}
        />
        <Route
          path="preventive/:id"
          element={<SingleManteinance type="preventive" />}
        />
      </Route>
      <Route path="digital">
        <Route index element={<Digital />} />
        <Route path="multi" element={<Multi />} />
        <Route path="intelligence" element={<DigitalIntelligenceDashboard />} />
        <Route path="prediction" element={<DigitalPredictionDashboard />}>
          <Route index element={<Descriptive />} />
          <Route path="risks" element={<Risks />} />
        </Route>
      </Route>
      <Route path="incidences">
        <Route index element={<IncidencesHome />} />
        <Route path="contract/:contractId" element={<Contract />} />
        <Route path="incident/:incidentId" element={<Incident />} />
      </Route>
      <Route path="change-pass" element={<ChangePass />} />
      <Route path="legal" element={<Legal />} />
      <Route path="not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
)

export default PrivateRoutes
